import React, { useEffect, useContext } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import TestYourCatalogue from 'components/TestYourCatalogue/testYourCatalogue'
import Login from 'components/auth/login/login'
import SignUp from 'components/auth/sign-up/signUp'
import PageNotFound from 'components/page-not-found/pageNotFound'
import ForgetPassword from 'components/auth/forget-password'
import Feedback from 'views/Feedback'
import Providers from 'pages/providers'
import Cookies from 'js-cookie'
import instance from 'services/axiosInstance'
import { deleteAllCookies } from 'utils/cookies'
import { ToastContext } from 'context/toastContext'
import { toast_actions, toast_types } from 'components/shared/toast/utils/toast'
import AppLayout from 'components/appLayout'
import Home from 'components/home/home'
import ProductRoutes from 'components/application/product-list/ProductRoutes'
import ProductDetails from 'components/application/product-list/product-details/productDetails'
import Cart from 'components/application/cart/cart'
import SearchProducts from 'components/SearchProducts/searchProducts'
import BrandRoutes from 'components/brand/BrandRoutes'
import TrackOrder from 'pages/track-order'
import AboutUsPage from 'pages/about-us'
import ReturnAndRefund from 'pages/returns-refund'
import TermsAndConditions from 'pages/terms-conditions'
import ShippingPolicy from 'pages/shipping-policy'
import CancellationPolicy from 'pages/cancellation-policy'
import PrivacyPolicy from 'pages/privacy-policy'
import ContactUs from 'pages/contact-us'
import FAQs from 'pages/faq'
import BharthamPurchaseProtection from 'pages/purchase-protection'
import ComplaintDetail from 'components/application/my-tickets/complaintDetail'
import MyOrder from 'components/myOrders'
import WishlistDetails from 'components/whislist'
import UserProfile from 'views/UserProfile'
import Stores from 'pages/stores'
import Checkout from 'components/checkout/checkout'
import MyTickets from 'components/application/my-tickets/myTickets'
import OrderDetails from 'components/orders/orderDetails/orderDetails'
import ProfileRoutes from 'profileRoutes' // Import ProfileRoutes
import TrackingComponent from 'trackingComponent'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Meta from 'components/meta'
import WapProductList from 'components/product/productList/wapProductList'

// import { BrowserRouter as Routes } from 'react-router-dom'
// import ProfileLayout from 'components/profileLayout'

const OndcRoutes = () => {
  const history = useHistory()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  //need to add GA as of application routes
  const dispatch = useContext(ToastContext)
  const REFRESH_INTERVAL = 55 * 60 * 1000

  const token = Cookies.get('refreshToken')
  const refreshToken = Cookies.get('refreshToken')

  useEffect(() => {
    if (refreshToken && token) {
      const getRefreshToken = async () => {
        try {
          const response = await instance.get('/clientApis/refresh-token', {
            headers: {
              refreshtoken: `${refreshToken}`,
            },
          })

          const newToken = response?.data?.token
          Cookies.set('token', newToken)
          localStorage.setItem('token', newToken)
        } catch (error) {
          dispatch({
            type: toast_actions.ADD_TOAST,
            payload: {
              id: Math.floor(Math.random() * 100),
              type: toast_types.warning,
              message: 'You are logged out, please log in again.',
            },
          })

          deleteAllCookies()
          localStorage.clear()
          history.push('/')
        }
      }

      // Call refreshToken immediately, then set interval
      getRefreshToken()

      const intervalId = setInterval(getRefreshToken, REFRESH_INTERVAL)

      // Cleanup interval on component unmount
      return () => clearInterval(intervalId)
    }
  }, [token, refreshToken])

  return (
    <Router>
      <TrackingComponent />
      <Meta />
      <Switch>
        {/* <Route path="/" component={Application} /> */}
        <Route path="/login" component={Login} />
        <Route path="/sign-up" component={SignUp} />
        <Route path="/forget-password" component={ForgetPassword} />
        {/* <Route path="/application" component={Application} /> */}
        <Route path="/testYourCatalogue" component={TestYourCatalogue} />
        <Route path="/feedback" component={Feedback} />

        <Route exact path="/">
          <AppLayout>
            <Home />
          </AppLayout>
        </Route>
        <Route exact path="/products">
          <AppLayout>
            <ProductRoutes />
          </AppLayout>
        </Route>
        <Route path="/products/:id">
          <AppLayout>
            <ProductDetails />
          </AppLayout>
        </Route>
        <Route path="/product/:domain/:category">
          <AppLayout>
            <WapProductList />
          </AppLayout>
        </Route>
        <Route path="/cart">
          <AppLayout>
            <Cart />
          </AppLayout>
        </Route>
        <Route path="/product-type">
          <AppLayout>
            <SearchProducts />
          </AppLayout>
        </Route>
        <Route path="/brand">
          <AppLayout>
            <BrandRoutes />
          </AppLayout>
        </Route>
        <Route exact path="/checkout">
          <AppLayout>
            <Checkout />
          </AppLayout>
        </Route>
        <Route path="/profile">
          <AppLayout>
            <ProfileRoutes /> {/* Add ProfileRoutes for profile-related routes */}
          </AppLayout>
        </Route>
        <Route path="/order/:orderId">
          <AppLayout>
            <OrderDetails />
          </AppLayout>
        </Route>
        <Route path="/complaints">
          <AppLayout>
            <MyTickets />
          </AppLayout>
        </Route>
        <Route path="/complaint/:issueId">
          <AppLayout>
            <ComplaintDetail />
          </AppLayout>
        </Route>
        <Route path="/orders">
          <AppLayout>
            <MyOrder />
          </AppLayout>
        </Route>
        <Route path="/wishlist">
          <AppLayout>
            <WishlistDetails />
          </AppLayout>
        </Route>
        <Route path="/user-info">
          <AppLayout>
            <UserProfile />
          </AppLayout>
        </Route>
        <Route path="/providers">
          <AppLayout>
            <Providers />
          </AppLayout>
        </Route>
        <Route path="/stores">
          <AppLayout>
            <Stores />
          </AppLayout>
        </Route>
        <Route path="/track-order/:orderId">
          <AppLayout>
            <TrackOrder />
          </AppLayout>
        </Route>
        <Route path="/about-us">
          <AppLayout>
            <AboutUsPage />
          </AppLayout>
        </Route>
        <Route path="/returns-refund">
          <AppLayout>
            <ReturnAndRefund />
          </AppLayout>
        </Route>
        <Route path="/terms-conditions">
          <AppLayout>
            <TermsAndConditions />
          </AppLayout>
        </Route>
        <Route path="/shipping-policy">
          <AppLayout>
            <ShippingPolicy />
          </AppLayout>
        </Route>
        <Route path="/cancellation-policy">
          <AppLayout>
            <CancellationPolicy />
          </AppLayout>
        </Route>
        <Route path="/privacy-policy">
          <AppLayout>
            <PrivacyPolicy />
          </AppLayout>
        </Route>
        <Route path="/contact-us">
          <AppLayout>
            <ContactUs />
          </AppLayout>
        </Route>
        <Route path="/faq">
          <AppLayout>
            <FAQs />
          </AppLayout>
        </Route>
        <Route path="/purchase-protection">
          <AppLayout>
            <BharthamPurchaseProtection />
          </AppLayout>
        </Route>

        {/* <Route component={PageNotFound} /> */}
        <Route>
          <AppLayout>
            <PageNotFound />
          </AppLayout>
        </Route>
      </Switch>
    </Router>
  )
}

export default OndcRoutes
